import { cleanup, render, screen } from '@testing-library/react';
import React from 'react';
import { describe, expect, test } from 'vitest';

import StorageConsumptionDisplay from './StorageConsumptionDisplay';
import translations from './translations';

translations.init();

describe('StorageConsumptionDisplay', () => {
  afterEach(() => {
    cleanup();
  });

  test('displays values in MB when under 1 GB', () => {
    render(
      <StorageConsumptionDisplay
        limitBytes={250 * 1024 * 1024}
        usedBytes={100 * 1024 * 1024}
      />,
    );

    expect(screen.getByText('100.0 MB / 250.0 MB (40%)')).toBeDefined();
  });

  test('displays values in GB when 1 GB or over', () => {
    render(
      <StorageConsumptionDisplay
        limitBytes={5 * 1024 * 1024 * 1024}
        usedBytes={1.5 * 1024 * 1024 * 1024}
      />,
    );

    expect(screen.getByText('1.50 GB / 5.00 GB (30%)')).toBeDefined();
  });

  test('displays values in KB when under 1 MB', () => {
    render(
      <StorageConsumptionDisplay
        limitBytes={250 * 1024 * 1024}
        usedBytes={512 * 1024}
      />,
    );

    expect(screen.getByText('512.0 KB / 250.0 MB (0%)')).toBeDefined();
  });

  test('caps percentage at 100% when usage exceeds limit', () => {
    render(
      <StorageConsumptionDisplay
        limitBytes={250 * 1024 * 1024}
        usedBytes={300 * 1024 * 1024}
      />,
    );

    expect(screen.getByText('300.0 MB / 250.0 MB (120%)')).toBeDefined();
  });

  test('displays 0% when limit is zero', () => {
    render(<StorageConsumptionDisplay limitBytes={0} usedBytes={0} />);

    expect(screen.getByText('0.0 KB / 0.0 KB (0%)')).toBeDefined();
  });
});
